import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormatDateService {

  toISODate(date: any): any {
    if (this.isIsoDate(date)) {
      return date;
    }
    date = new Date(date);
    date = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
    return date;
  }

  private isIsoDate(date: any) {
    return /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(date);
  }
}
